export default "__VITE_ASSET__bh6$ksJr__"